type LogLevel = "debug" | "info" | "warn" | "error";

interface LogEntry {
  timestamp: Date;
  level: LogLevel;
  widgetId: string;
  message: string;
  data?: unknown;
}

class WidgetLogger {
  private static instance: WidgetLogger;
  private logs: LogEntry[] = [];
  private maxLogs = 1000;
  private enabled = process.env['NODE_ENV'] === "development";

  private constructor() {}

  static getInstance(): WidgetLogger {
    if (!WidgetLogger.instance) {
      WidgetLogger.instance = new WidgetLogger();
    }
    return WidgetLogger.instance;
  }

  private addLog(
    level: LogLevel,
    widgetId: string,
    message: string,
    data?: unknown
  ): void {
    if (!this.enabled) return;

    const entry: LogEntry = {
      timestamp: new Date(),
      level,
      widgetId,
      message,
      data,
    };

    this.logs.push(entry);
    if (this.logs.length > this.maxLogs) {
      this.logs.shift();
    }

    // Выводим в консоль в development
    if (process.env['NODE_ENV'] === "development") {
      const consoleMethod = level === "debug" ? "log" : level;
      // eslint-disable-next-line no-console
      console[consoleMethod](
        `[${entry.timestamp.toISOString()}] [${level.toUpperCase()}] [${widgetId}] ${message}`,
        data || ""
      );
    }
  }

  debug(widgetId: string, message: string, data?: unknown): void {
    this.addLog("debug", widgetId, message, data);
  }

  info(widgetId: string, message: string, data?: unknown): void {
    this.addLog("info", widgetId, message, data);
  }

  warn(widgetId: string, message: string, data?: unknown): void {
    this.addLog("warn", widgetId, message, data);
  }

  error(widgetId: string, message: string, data?: unknown): void {
    this.addLog("error", widgetId, message, data);
  }

  getLogs(widgetId?: string, level?: LogLevel): LogEntry[] {
    return this.logs.filter(
      (log) =>
        (!widgetId || log.widgetId === widgetId) &&
        (!level || log.level === level)
    );
  }

  clearLogs(widgetId?: string): void {
    if (widgetId) {
      this.logs = this.logs.filter((log) => log.widgetId !== widgetId);
    } else {
      this.logs = [];
    }
  }

  enable(): void {
    this.enabled = true;
  }

  disable(): void {
    this.enabled = false;
  }
}

export const widgetLogger = WidgetLogger.getInstance();
